import { createI18n } from 'vue-i18n'
import en from './en'
import zhCn from './zh-cn'
import zhTw from './zh-tw'

const messages = {
  en,
  'zh-cn': zhCn,
  'zh-tw': zhTw
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'zh-cn',
  fallbackLocale: 'en',
  messages
})

export default i18n